import { memoize } from 'lodash';
import React, { useMemo } from 'react';
import Input from './Input';

export const FastInput = (props: any) => {
  const validate = useMemo(() => {
    return memoize(props.validate);
  }, [props.validate]);

  return <Input {...props} validate={validate} />;
};

export default FastInput;
